// src/common/i18n/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// 각 언어별 JSON 파일을 import
import translation_en from "./locales/en/translation.json";
import translation_ko from "./locales/ko/translation.json";
import translation_vi from "./locales/vi/translation.json";

import webPush_en from "./locales/en/webPush.json";
import webPush_ko from "./locales/ko/webPush.json";
import webPush_vi from "./locales/vi/webPush.json";

// i18next 초기화 및 설정
i18n
  .use(LanguageDetector) // 언어 자동 감지
  .use(initReactI18next) // react-i18next 연동
  .init({
    resources: {
      en: { translation: translation_en, webPush: webPush_en },
      ko: { translation: translation_ko, webPush: webPush_ko },
      vi: { translation: translation_vi, webPush: webPush_vi },
    },
    fallbackLng: "en", // 기본 언어 설정 (언어가 없으면 영어로 fallback)
    interpolation: {
      escapeValue: false, // React가 자동으로 XSS를 처리하므로 escape 하지 않음
    },
    ns: ["translation", "webPush"],
    defaultNS: "translation",
    detection: {
      order: ["localStorage"], // 언어 감지 순서
      caches: ["localStorage"], // localStorage에 언어 저장
    },
  });

export default i18n; // i18n 설정을 export
